import User from "../../types/User";
import userDisplayName from "../formatters/userDisplayName";

const userDisplayNameComparator = (
  a: Pick<User, "fullName" | "username">,
  b: Pick<User, "fullName" | "username">
) => userDisplayName(a).localeCompare(userDisplayName(b));

export default userDisplayNameComparator;
